import { useState, useEffect } from "react";
import { Factory } from "lucide-react";
import { FieldText, FieldSelect } from "./champs";
import { fmtDate } from "@/lib/format";

// Chantier 3f : bloc Commande usine — historique des dates CONSERVÉ, jamais écrasé.
export default function BlocCommandeUsine({ adm, onPatch, canEdit }) {
  const cu = adm.commande_usine || {};
  const [form, setForm] = useState(cu);
  const [motifReport, setMotifReport] = useState("");
  useEffect(() => { setForm(cu); /* eslint-disable-next-line */ }, [JSON.stringify(cu)]);

  const historique = cu.historique_dates || [];
  const ecartJours = (() => {
    if (!cu.date_prevue_initiale || !cu.date_prevue_actuelle) return null;
    const d1 = new Date(cu.date_prevue_initiale.slice(0, 10));
    const d2 = new Date(cu.date_prevue_actuelle.slice(0, 10));
    return Math.round((d2 - d1) / 86400000);
  })();

  return (
    <div data-testid="bloc-commande-usine">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-[12.5px]">
        <FieldSelect label="Mode d'approvisionnement" value={form.mode || "commande"} disabled={!canEdit}
          onChange={(v) => { setForm({ ...form, mode: v }); onPatch({ mode: v }); }}
          options={[["stock", "Stock (véhicule disponible)"], ["commande", "Commande usine"],
            ["agent", "Agent (hors stock propriétaire)"]]}
          testId="cu-mode" />
        <FieldSelect label="Statut OEM" value={form.statut_oem || "a_transmettre"} disabled={!canEdit}
          onChange={(v) => { setForm({ ...form, statut_oem: v }); onPatch({ statut_oem: v }); }}
          options={[["a_transmettre", "À transmettre"], ["transmise", "Transmise"], ["acceptee", "Acceptée"],
            ["en_production", "En production"], ["produite", "Produite"], ["en_transit", "En transit"],
            ["arrivee", "Arrivée"], ["annulee", "Annulée"]]}
          testId="cu-statut-oem" />
        <FieldText label="N° commande OEM" value={form.numero_oem || ""} disabled={!canEdit}
          onBlur={(v) => onPatch({ numero_oem: v })}
          onChange={(v) => setForm({ ...form, numero_oem: v })} testId="cu-numero-oem" />
        <FieldText label="VIN" value={form.vin || ""} disabled={!canEdit}
          onBlur={(v) => onPatch({ vin: v })}
          onChange={(v) => setForm({ ...form, vin: v })} testId="cu-vin" />
        <FieldText label="Date commande" type="date" value={(form.date_commande || "").slice(0, 10)} disabled={!canEdit}
          onBlur={(v) => onPatch({ date_commande: v })}
          onChange={(v) => setForm({ ...form, date_commande: v })} testId="cu-date-commande" />
        <FieldText label="Date prévue initiale" type="date" value={(form.date_prevue_initiale || "").slice(0, 10)} disabled={!canEdit}
          onBlur={(v) => onPatch({ date_prevue_initiale: v })}
          onChange={(v) => setForm({ ...form, date_prevue_initiale: v })} testId="cu-date-initiale" />
      </div>

      {form.mode === "agent" && (
        <p className="mt-2 text-[11.5px] text-[#9A3412] bg-[#FFF7ED] border border-[#FED7AA] rounded px-2 py-1.5"
          data-testid="cu-avertissement-agent">
          Mode <b>agent</b> : le véhicule n'entre pas au stock propriétaire — il n'est pas valorisé dans le stock du site.
        </p>
      )}

      <div className="mt-3 p-3 bg-[#F1F4F9] rounded-lg">
        <div className="text-[11px] font-bold uppercase tracking-wider text-[--idc-muted] mb-2 flex items-center gap-2">
          <Factory className="w-3.5 h-3.5" /> Nouvelle date annoncée par le constructeur
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <FieldText label="Date annoncée" type="date" value={(form.date_prevue_actuelle || "").slice(0, 10)}
            disabled={!canEdit}
            onChange={(v) => setForm({ ...form, date_prevue_actuelle: v })}
            onBlur={(v) => v && v !== (cu.date_prevue_actuelle || "").slice(0, 10) &&
              onPatch({ date_prevue_actuelle: v, motif_report: motifReport || null })}
            testId="cu-date-actuelle" />
          <FieldText label="Motif du report (facultatif)" value={motifReport} disabled={!canEdit}
            onChange={(v) => setMotifReport(v)} testId="cu-motif-report" />
        </div>
        {ecartJours != null && ecartJours !== 0 && (
          <p className="mt-2 text-[12px] font-semibold" data-testid="cu-ecart"
            style={{ color: ecartJours > 0 ? "#B91C1C" : "#16A34A" }}>
            Écart vs date initiale : {ecartJours > 0 ? "+" : ""}{ecartJours} jour(s)
          </p>
        )}
      </div>

      {historique.length > 0 && (
        <div className="mt-3">
          <div className="text-[11px] font-bold uppercase tracking-wider text-[--idc-muted] mb-1.5">
            Historique des dates annoncées ({historique.length})
          </div>
          <ul className="space-y-1" data-testid="cu-historique-dates">
            {historique.map((h, i) => (
              <li key={`${h.date_annoncee}-${h.constatee_le}-${i}`} className="text-[12px] text-[--idc-muted]">
                <span className="font-mono">{fmtDate(h.constatee_le)}</span> → annonce du{" "}
                <b className="text-[--idc-text]">{fmtDate(h.date_annoncee)}</b>
                {h.motif && <span> · {h.motif}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
